module.exports = __webpack_public_path__ + "static/img/m_role.000c04b.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/mx/m_role.png
// module id = vNKE
// module chunks = 7